<div *ngIf="allActions && allActions.length > 0" class="container">
  <h2 class="title" i18n id="processed">Processed Images</h2>
  <a href="#" i18n>Go back to the unprocessed images</a>
  <div class="actionContainer">
  <mat-card *ngFor="let actEl of allActions; let i = index" class="actionEl">
    <h3 class="actionTitle">{{ actEl.text }}</h3>
    <mat-card-content>
      <div class="images">
        <figure *ngIf="actEl.imgFrom">
          <img
          height="150"
          [src]="
              actEl.imgFrom.base64 ||
              actEl.imgFrom.thumbnailSource ||
              actEl.imgFrom.source
              "
              />
              <figcaption>
                <span i18n>Original Image</span><br />
                <i>{{ actEl.imgFrom.title }}</i
                  ><br />
                </figcaption>
              </figure>
              <mat-icon *ngIf="actEl.imgFrom && actEl.imgTo" class="toIcon"
              >arrow_right</mat-icon
              >
              <figure *ngIf="actEl.imgTo">
                <img
            height="150"
            [src]="
            actEl.imgTo.edited?.base64 ||
            actEl.imgTo.base64 ||
            actEl.imgTo.thumbnailSource ||
            actEl.imgTo.source
            "
          />
          <figcaption>
            <span i18n>Replacement Image</span>
            <br />
            <i>{{ actEl.imgTo.title }}</i
              ><br />
              <span i18n>Origin: {{ actEl.imgTo.origin }}</span>
            </figcaption>
          </figure>
        </div>
        <p *ngIf="actEl.details">{{actEl.details}}</p>
    </mat-card-content>
    <div class="cardActionDiv">
      <mat-divider inset></mat-divider>
      <button class="fullWidthButton" mat-button color="warn" (click)="deleteAction(actEl, i)" i18n>Undo</button>
      <!-- <mat-card-actions>
      </mat-card-actions> -->
    </div>
</mat-card>

<!-- <div *ngFor="let actEl of allActions; let i = index" class="actionEl">
  <div class="actionHeader">
    <h3>{{ actEl.text }}</h3>
    <button mat-icon-button class="deleteButton" (click)="deleteAction(actEl, i)"><mat-icon>cancel</mat-icon></button>
  </div>
  
</div> -->
</div>
</div>